export default __webpack_public_path__ + "static/header-resources-c2aada2a735b92c203928748581aef4a.jpg";